import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { joiResolver } from '@hookform/resolvers/joi'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../services/lib'
import { createAnalyzer, updateAnalyzer } from '../../../redux/slices'
import { analyzerSchema } from './analyzer.schema'
import AnalyzerForm from './AnalyzerForm'
import { DefaultState } from '../../../types'
interface Props {
  isEdit?: boolean
  selectedAnalyzer?: any
  onSuccess?: (analyzer: any) => void
}

const AnalyzerFormWrapper = ({
  isEdit = false,
  selectedAnalyzer,
  onSuccess
}: Props) => {
  const dispatch: AppDispatch = useDispatch()
  const userData = useSelector((state: DefaultState) => state.session.data.user)
  const isAdmin = userData?.roles?.includes('admin') ? true : false

  const defaultValues = isEdit
    ? {
        name: selectedAnalyzer.name,
        description: selectedAnalyzer.description,
        type:
          selectedAnalyzer.type === 'ingress'
            ? 'Ingress'
            : selectedAnalyzer.type === 'manual'
            ? 'Manual'
            : selectedAnalyzer.type,
        scriptId: selectedAnalyzer.script.id,
        configId: selectedAnalyzer.configs?.[0]?.id,
        datasetId: selectedAnalyzer.datasets?.[0]?.id,
        scriptExecUser: selectedAnalyzer.script_exec_user?.toString() ?? ''
      }
    : {
        name: '',
        description: '',
        type: 'Manual',
        scriptId: '',
        configId: '',
        datasetId: '',
        scriptExecUser: ''
      }

  const methods = useForm({
    resolver: joiResolver(analyzerSchema),
    defaultValues,
    mode: 'onChange'
  })

  const { formState } = methods

  const handleSubmit = async (formData: any) => {
    const payload = {
      name: formData.name,
      script_id: formData.scriptId,
      configs: [formData.configId],
      datasets: [formData.datasetId],
      type: formData.type.toLowerCase(),
      frequency: {
        interval: '',
        start_schedule: '0000-00-00T00:00:00.000Z'
      },
      description: formData.description,
      script_exec_user:
        formData.scriptExecUser !== '' ? Number(formData.scriptExecUser) : null
    }

    const result = isEdit
      ? await dispatch(
          updateAnalyzer({ id: selectedAnalyzer.id, changes: payload })
        )
      : await dispatch(createAnalyzer(payload))

    if (result.type.endsWith('fulfilled')) {
      const returnedAnalyzer = isEdit ? selectedAnalyzer : result.payload
      onSuccess?.(returnedAnalyzer)
    }
  }

  return (
    <FormProvider {...methods}>
      <AnalyzerForm
        onSubmit={methods.handleSubmit(handleSubmit)}
        isEdit={isEdit}
        isDirty={formState.isDirty}
        isAdmin={isAdmin}
      />
    </FormProvider>
  )
}

export default AnalyzerFormWrapper
